import decorativo from '../../../Assets/img/shape13.svg'
import { Hero } from '../Components/Hero'
import { PorQueElegirnos } from '../Components/PorQueElegirnos'
import PropuestaValor from '../Components/PropuestaValor'
import Asesoramiento from '../Components/Asesoramiento'
import Formulario from '../Components/Formulario';
import useSEOConfig from "../../../hooks/seo/useSEOConfig"
import { Navbar } from "../Components/Navbar"
import { useConfig } from '../../../context/ConfigContext'
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

export const Transporte = () => {

    const {origen:parametros, config} = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros para Empresas & Pymes - Protegé tu inversión ante todo riesgo",
            description: textoSeo?.description ?? "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            tituloCompleto: !!textoSeo,
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle:
                config.pais === "UY" ?
                    "Segurarse - Corredor de Seguros digital"
                    : "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )

    return (
        <>
            <Navbar
                rubro="auto"
            />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro para Transporte'
                    url='#formulario'
                    icon='#icon-seg-transporte'
                    subTitulo={{ __html: " Protegé el traslado de tus mercaderías con un plan diseñado a medida de tu negocio.<br/><br/>¿Empezamos?" }}
                    color={parametros!.origen !== "SEGURARSE" ? parametros!.bgColor : undefined}
                />
                <div className={`pt-70 pt-lg-80 pb-40 position-relative ${parametros!.origen === "SEGURARSE" && "bg-primary"}`}
                    style={parametros!.origen !== "SEGURARSE" ? { backgroundColor: parametros!.bgColor } : {}}>
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Conocemos los riesgos a los que está expuesta tu mercadería a diario durante el traslado, ya sea por vía terrestre, marítima, aérea o ferroviaria.  Por eso, ponemos a disposición una gran variedad de coberturas que se ajustan a la necesidad de tu negocio.
                            </p>
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Dentro de las principales coberturas, se incluyen:
                            </p>
                        </div>

                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Daños o pérdidas físicas:</b> este tipo de cobertura protege contra daños o pérdidas físicas de las mercancías durante el transporte. Incluye daños causados por accidentes, incendios, robos, vandalismo o desastres naturales.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Robo o hurto:</b> el seguro puede cubrir el robo o hurto de las mercancías durante el transporte. Esto incluye tanto el robo total como el robo parcial de los bienes.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Pérdida total:</b> si las mercancías se pierden por completo durante el transporte debido a un evento cubierto, el seguro de transporte de mercancías puede proporcionar indemnización por el valor total de las mercancías perdidas.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                            <b>Gastos de salvamento:</b> en caso de un evento que ponga en peligro las mercancías, el seguro de transporte puede cubrir los gastos de salvamento incurridos para proteger o recuperarlas.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Formulario
                    rubro='Transporte'
                    titulo='Cotizá seguro para Transporte'
                    origen={config.pais === "UY" ? "UY-SEGURARSE" : parametros!.origen}
                    color={parametros!.bgColor}
                />
                <PorQueElegirnos color={parametros!.bgColor} />
                <PropuestaValor
                    origen={parametros!.origen}
                    color={parametros!.bgColor}
                />
                {/* {parametros!.origen === "SEGURARSE" &&
                    <Asesoramiento />
                } */}
            </div>
        </>
    )
}
